import { render, staticRenderFns } from "./ForceLogout.vue?vue&type=template&id=b33b672e"
import script from "./ForceLogout.vue?vue&type=script&lang=js"
export * from "./ForceLogout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports